
export enum ParticipantType {
  NonChevronUser = 1,
  ChevronOrSharedUser = 2,
  External = 3
}
